import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment/moment";
import { SessionManager, getConfig } from "../../../../utils";

export const updateProfile = createAsyncThunk('updateProfile', async ({ values }) => {

    var bodyFormData = new FormData()

    bodyFormData.append(
        "id", values.id
    )
    bodyFormData.append(
        "first_name", values.first_name
    )
    bodyFormData.append(
        "last_name", values.last_name
    )
    bodyFormData.append(
        "gender", values.gender
    )
    bodyFormData.append(
        "dob", moment(values.dob, 'DD/MM/YYYY').format('YYYY-MM-DD')
    )
    bodyFormData.append(
        "email", values.email
    )
    bodyFormData.append(
        "mobile_number", values.mobile_number
    )
    {
        values?.profile &&
            bodyFormData.append(
                "profile", values.profile
            )
    }
    bodyFormData.append(
        "district", values.district
    )
    bodyFormData.append(
        "address", values.address
    )

    try {
        const res = await axios({

            method: "post",
            url: getConfig.API_URL + 'update_profile',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", 'type': 'profile', "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})